import { useMutation } from '@tanstack/react-query'
import { api } from '@/lib/api'
import { toast } from '@/components/ui/Toast'
import { useAuthStore } from '@/store/auth.store'
import type { UpdateProfile, Profile } from '@parchala/shared'

export function useUpdateProfile() {
  const setProfile = useAuthStore((s) => s.setProfile)

  return useMutation({
    mutationFn: (data: UpdateProfile) => api.patch<{ data: Profile }>('/api/profile', data),
    onSuccess: (res) => {
      setProfile(res.data)
      toast.success('Perfil actualizado ✓')
    },
    onError: (err: Error) => toast.error(err.message),
  })
}

/** Descarga una copia de todos los datos del usuario como archivo JSON. */
export function useExportData() {
  return useMutation({
    mutationFn: () => api.get<Record<string, unknown>>('/api/profile/export'),
    onSuccess: (data) => {
      const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' })
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = `parchala-mis-datos-${new Date().toISOString().slice(0, 10)}.json`
      a.click()
      URL.revokeObjectURL(url)
      toast.success('Descarga lista ✓')
    },
    onError: (err: Error) => toast.error(err.message),
  })
}

/** Elimina la cuenta del usuario logueado (irreversible). */
export function useDeleteAccount() {
  const reset = useAuthStore((s) => s.reset)

  return useMutation({
    mutationFn: () => api.delete('/api/profile'),
    onSuccess: () => reset(),
    onError: (err: Error) => toast.error(err.message),
  })
}
